module.exports = __webpack_public_path__ + "static/simple-area-450e0ec71f4bc80a0c7a4b1f073b58ca.png";